import { useCookies } from "@vueuse/integrations/useCookies";
import { ref } from "vue";

export function useCompliance() {
  const apiResponse = ref(undefined);
  const timestamp = ref(undefined);
  const parsedResult = ref({});
  const abortMethod = ref(null);
  const lastRawResponse = ref({});
  const midCheck = ref(false);

  async function checktext(text) {
    midCheck.value = true;
    const cookies = useCookies(["csrftoken"]);
    const checkdata = {
      method: "POST",
      headers: {
        "X-CSRFToken": cookies.get("csrftoken"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: text,
      }),
    };
    const response = await fetch(`/api/compliance/check/`, checkdata);
    if (!response.ok) {
      midCheck.value = false;
      error_message.value =
        "uh-oh, something went wrong. We're unable to check your suggestion at this time, please try again later.";
      const error = new Error("Compliance check failed");
      error.response = response;
      throw error;
    }
    if (response.ok) {
      midCheck.value = false;
    }
    const data = await response.json();
    lastRawResponse.value = data;
    midCheck.value = false;

    const {
      lexiconViolations = [],
      collapsedViolations = [],
      generalViolations = [],
      categoryViolations = [],
      isCompliant,
    } = data.compliance?.assessment ?? {};

    const spellingMistakes = data.spelling?.map((r) => ({
      value: r.origWord,
      message: r.suggestions ? "Did you mean..." : "Word may be misspelled",
      options: r.suggestions,
      overrideClass: "underline-blue",
      type: "spelling",
    }));
    const sanitations =
      data.sanitizer?.map((s) => ({
        message: "this text is not allowed",
        isWord: false,
        value: s,
      })) ?? [];

    const isSanitized = data.sanitizer === null || data.sanitizer?.length === 0;

    const newParsedResult = {
      lexiconViolations,
      collapsedViolations,
      generalViolations,
      categoryViolations,
      spellingMistakes,
      sanitations,
      isSanitized,
      isCompliant,
    };

    apiResponse.value = data.value || {};
    parsedResult.value = newParsedResult;
  }

  function clearCompliance() {
    abortMethod.value?.();
    apiResponse.value = undefined;
    timestamp.value = undefined;
    parsedResult.value = {};
  }
  return {
    checktext,
    parsedResult,
    apiResponse,
    clearCompliance,
    lastRawResponse,
    midCheck,
  };
}
